import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const ConfluenceAiInEditorModalWithErrorBoundaryLoadable: LoadableType<{
	experienceUrl: string;
	onClose?: () => void;
	onRender?: () => void;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ConfluenceAiInEditorModalWithErrorBoundary" */ '../src/ui/AiInEditorModal/index.tsx'
			)
		).ConfluenceAiInEditorModalWithErrorBoundary,
});
